// src/pages/manage-users/components/invite-dialog.tsx
import Dialog from '@/components/Dialog';
import { useManageStaffStore } from '../../store/useManageStaffStore';
import Button from '@/components/Button';
import Pagination from '@/components/Pagination';
import { RowData } from '../../hooks/useInviteStaff';

type Props = {
  open?: boolean;
  setOpen: React.Dispatch<boolean>;
  data: RowData[];
  totalPages: number;
  currentPage: number;
  onChangePage: (page: number) => void;
  onConfirmSend: () => void;
  loadingConfirm: boolean;
};

export const InviteDialog: React.FC<Props> = ({
  open,
  setOpen,
  data,
  totalPages,
  currentPage,
  onChangePage,
  onConfirmSend,
  loadingConfirm,
}: Props) => {
  const inviteStaffData = useManageStaffStore((state) => state?.page?.inviteStaff);

  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      title={inviteStaffData?.dialogTitle || ''}
      body={
        <>
          <p className="mb-4 text-left text-sh-16-24">{inviteStaffData?.dialogDescription || ''}</p>

          <table className="w-full table-auto">
            <thead>
              <tr>
                <th className="border border-primary-300 bg-white px-4 py-2 text-left">Surname</th>
                <th className="border border-primary-300 bg-white px-4 py-2 text-left">Forename</th>
                <th className="border border-primary-300 bg-white px-4 py-2 text-left">Email</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td className="border px-4 py-2 text-left">{row.surname}</td>
                  <td className="border px-4 py-2 text-left">{row.forename}</td>
                  <td className="border px-4 py-2 text-left">{row.email}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {totalPages > 1 && <Pagination currentPage={currentPage} pageSize={totalPages} onChangePage={onChangePage} />}

          <div className="flex justify-end gap-4">
            <Button
              theme="solid"
              className="mr-auto mt-5"
              onClick={onConfirmSend}
              loading={loadingConfirm}
              disabled={loadingConfirm || data.length === 0}>
              {inviteStaffData?.dialogConfirmButton || ''}
            </Button>
          </div>
        </>
      }
    />
  );
};
